import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CANONICAL_ORIGIN = 'https://autoxium.com';

// Mounted once near the app root. Keeps <link rel="canonical"> pointing at
// https://autoxium.com + the current path (no query string, no trailing slash), so any
// other host serving this same build (e.g. another domain aimed at the VPS) and
// trailing-slash variants are consolidated onto the autoxium.com URL in search results.
// Not in public/index.html: every route is served that same file, so a static tag
// would declare every page a duplicate of the home page before JS runs.
const CanonicalLink = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', CANONICAL_ORIGIN + path);
  }, [pathname]);

  return null;
};

export default CanonicalLink;
